export default {
  methods: {
    isValidTime(time) {
      return time && time !== '-' && time !== '23:59' && time !== '00:01';
    }
  }
}
